import { inject } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { UISnackbarService } from '@ui/components';
import { catchError, map, Observable, of } from 'rxjs';
import { BeneficiaryPolicyStatus, PolicyStatusGQL, PolicyStatusQuery } from '../generated/shared.model';

export const POLICY_NOT_STARTED_MESSAGE: string =
  'This policy has not started yet. You can submit claims and pre-authorizations once it is active.';

export const sharedStartedPolicyGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const policyStatus: PolicyStatusGQL = inject(PolicyStatusGQL);
  const router: Router = inject(Router);
  const snackbar: UISnackbarService = inject(UISnackbarService);
  const beneficiaryPolicyId: string = route.params['beneficiaryPolicyId'];

  return policyStatus.fetch({ variables: { beneficiaryPolicyId } }).pipe(
    map(
      ({ data }: { data: PolicyStatusQuery }) => data.beneficiaryPolicy?.status !== BeneficiaryPolicyStatus.Scheduled,
    ),
    catchError(() => of(true)),
    map((hasStarted: boolean) => {
      if (hasStarted) {
        return true;
      }
      snackbar.showNeutral(POLICY_NOT_STARTED_MESSAGE);
      return router.createUrlTree(['/product', beneficiaryPolicyId]);
    }),
  );
};
